import { useState, useEffect } from "react";
import "./LeadPopup.css";

export default function LeadPopup() {
  const [isOpen, setIsOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [status, setStatus] = useState("idle"); // idle, loading, success, error

  // Show on every reload/visit
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsOpen(true);
    }, 2000); 
    return () => clearTimeout(timer);
  }, []);

  const closePopup = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsOpen(false);
      setIsClosing(false);
    }, 500); // match CSS animation duration
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");

    const formData = new FormData(e.target);
    const params = new URLSearchParams();
    for (const [key, value] of formData) {
      params.append(key, value);
    }

    const GOOGLE_SHEET_URL = "https://script.google.com/macros/s/AKfycbyJhF3O01ItxVhlhcWg-tAG9kdGfy_kr8NZ6_S6Xt4UO2cE2_ABjqsxbdHloGUWSq5Vhw/exec";

    try {
      if (GOOGLE_SHEET_URL.includes("YOUR_GOOGLE_APPS_SCRIPT_URL_HERE")) {
          console.warn("Google Sheet URL not configured correctly. Form data:", Object.fromEntries(formData));
          setTimeout(() => {
              setStatus("success");
              setTimeout(closePopup, 1500);
          }, 1000);
          return;
      }

      await fetch(GOOGLE_SHEET_URL, {
        method: "POST",
        mode: "no-cors",
        body: params,
      });

      setStatus("success");
      setTimeout(closePopup, 1500);
    } catch (err) {
      console.error(err);
      setStatus("error");
    }
  };

  if (!isOpen) return null;

  return (
    <div className={`lp-overlay ${isClosing ? 'closing' : ''}`}>
      <div className={`lp-modal ${isClosing ? 'closing' : ''}`}>
        <button className="lp-close" onClick={closePopup}>✕</button>
        
        <div className="lp-content">
          <span className="lp-tag">Limited Mandates</span>
          <h2 className="lp-h2">Initiate a Strategic Conversation</h2>
          <p className="lp-p">Connect with our advisory team for institutional-grade real estate solutions.</p>

          <form className="lp-form" onSubmit={handleSubmit}>
            <div className="lp-field">
              <input type="text" name="name" placeholder="Full Name" required />
            </div>
            <div className="lp-field">
              <input type="email" name="email" placeholder="Email Address" required />
            </div>
            <div className="lp-field">
              <input type="tel" name="phone" placeholder="Phone Number" required />
            </div>
            <div className="lp-field">
              <select name="interest" required defaultValue="">
                <option value="" disabled>Interested In</option>
                <option value="Land Advisory">Land Advisory</option>
                <option value="Capital Raise">Capital Raise</option>
                <option value="Deal Structuring">Deal Structuring</option>
                <option value="General Enquiry">General Enquiry</option>
              </select>
            </div>
            
            <button 
              type="submit" 
              className={`lp-submit btn ${status === 'loading' ? 'loading' : 'btn-r'}`}
              disabled={status === "loading"}
            >
              {status === "idle" && "Request Call Back"}
              {status === "loading" && "Processing..."}
              {status === "success" && "Enquiry Sent!"}
              {status === "error" && "Try Again"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
